// Mind2Magic CRM — Supabase Client
// Replaces the CDN-loaded window.supabase with npm import.

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
    || 'https://kzrjjlrlowjazufeizce.supabase.co'
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY
    || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6cmpqbHJsb3dqYXp1ZmVpemNlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAyNTU4NzksImV4cCI6MjA4NTgzMTg3OX0.me2S-upa8HqvPrx1VcuR-HtEvezNF_tTFHbirpAiRa4'

const SCHEMA = import.meta.env.VITE_SUPABASE_SCHEMA || undefined
export const sb = createClient(SUPABASE_URL, SUPABASE_ANON_KEY,
    SCHEMA ? { db: { schema: SCHEMA } } : {})
export { SUPABASE_URL }

// Bridge: expose for inline module and supabaseDB
window.sb = sb
window.SUPABASE_URL = SUPABASE_URL
